
$(function () {
    // console.log($(window).scrollTop());
    $(window).scroll(function () {
        if ($(window).scrollTop() > 1) {
            $('#tabtop').addClass('animated fadeInDown')
        } else {
            // $("#tabtop").fadeOut(1000);
        }
        // if ($('#toplink').scrollTop() < 1200) {
        //     console.log(11111);
        //     $('#toplink').addClass('toplinktwo')
        // } else {
        //     console.log(22222);
        //     $('#toplink').addClass('toplinkone')
        // }

    });
    window.onscroll = function () {

        var scrollTop = document.documentElement.scrollTop ?

            document.documentElement.scrollTop :

            document.body.scrollTop;

        if (scrollTop > 310) {
            console.log(11111);

            $('#toplink').addClass('toplinkone')

        } else {
            console.log(22222);

            $('#toplink').removeClass('toplinkone')

        }

    }

})


//////////////////
// WEBPACK FOOTER
// ./utils/toptab.js
// module id = JhNw
// module chunks = 1